import { useState } from 'react';
import _ from 'lodash';
import { classNames } from '@progress/kendo-react-common';
import { faFileExcel, faFilePdf, faFileCircleQuestion, faFilePng, faFileJpg, faFileGif, faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoaderOverlay } from 'components';
import { FileExtensions } from 'enums';
import { AttachedDocument } from 'types';
import styles from './FileCard.module.scss';

const FileIcons = {
    [FileExtensions.CSV]: faFileExcel,
    [FileExtensions.Excel]: faFileExcel,
    [FileExtensions.ExcelModern]: faFileExcel,
    [FileExtensions.PDF]: faFilePdf,
    [FileExtensions.PNG]: faFilePng,
    [FileExtensions.JPEG]: faFileJpg,
    [FileExtensions.JPG]: faFileJpg,
    [FileExtensions.GIF]: faFileGif,
    [FileExtensions.MSG]: faEnvelope
};

const imageIcons = [faFilePng, faFileJpg, faFileGif];

type FileProps = {
    fileName: string,
    fileLink?: string,
    document?: AttachedDocument,
    onClick?: (document: AttachedDocument) => Promise<void>
}

export default function FileCard({ fileName, document, onClick }: FileProps) {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
    const icon = _.get(FileIcons, fileExtension as keyof typeof FileExtensions, faFileCircleQuestion);

    const handleClick = async () => {
        if (onClick && document) {
            setIsLoading(true);
            await onClick(document);
            setIsLoading(false);
        }
    };

    return (
        <div tabIndex={0} className={styles.container}>
            <div className={styles.card} onClick={handleClick} title={fileName}>
                <div className={classNames(styles.icon, {
                    [styles.excel]: icon === faFileExcel,
                    [styles.pdf]: icon === faFilePdf,
                    [styles.msg]: icon === faEnvelope,
                    [styles.image]: imageIcons.includes(icon),
                    [styles.unknown]: icon === faFileCircleQuestion
                })}>
                    <FontAwesomeIcon
                        icon={icon}
                        transform="grow-22"
                    />
                </div>
                <div className={styles.description}>
                    <span className={styles.name}>
                        {fileName}
                    </span>
                </div>
            </div>
            <LoaderOverlay isLoading={isLoading} />
        </div>
    );
}